import React from 'react';
import PropTypes from 'prop-types';

import AspectRatioBox from '@components/shared/AspectRatioBox/AspectRatioBox';
import Loader from '@components/shared/Loader/Loader';

import styles from './CarouselImagePlaceholder.module.scss';

CarouselImagePlaceholder.propTypes = {
  aspectRatio: PropTypes.number,
  className: PropTypes.string,
};

CarouselImagePlaceholder.defaultProps = {
  aspectRatio: 10 / 16,
  className: '',
};

export default function CarouselImagePlaceholder(props) {
  const {
    aspectRatio,
    className,
  } = props;

  return (
    <AspectRatioBox aspectRatio={ aspectRatio }>
      <div className={ `${styles.LoaderContainer} ${className}` }>
        <Loader />
      </div>
    </AspectRatioBox>
  );
}
